namespace Gamification.Gamification {
    export interface UtentiRow {
        IdUtente?: number;
        UserId?: number;
        TenantId?: number;
        IdProdotto?: number;
        IdentifierUtente?: string;
        Cognome?: string;
        Nome?: string;
        Email?: string;
        Locked?: number;
        Password?: string;
        Token?: string;
        IdProdottoNome?: string;
        IdProdottoDescrizione?: string;
        Classi?: number[];
    }

    export namespace UtentiRow {
        export const idProperty = 'IdUtente';
        export const nameProperty = 'Email';
        export const localTextPrefix = 'Gamification.Utenti';
        export const lookupKey = 'Gamification.Utenti';

        export function getLookup(): Q.Lookup<UtentiRow> {
            return Q.getLookup<UtentiRow>('Gamification.Utenti');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            IdUtente = "IdUtente",
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdotto = "IdProdotto",
            IdentifierUtente = "IdentifierUtente",
            Cognome = "Cognome",
            Nome = "Nome",
            Email = "Email",
            Locked = "Locked",
            Password = "Password",
            Token = "Token",
            IdProdottoNome = "IdProdottoNome",
            IdProdottoDescrizione = "IdProdottoDescrizione",
            Classi = "Classi"
        }
    }
}
